import { render, staticRenderFns } from "./LightBox.vue?vue&type=template&id=3c58f82f&scoped=true&lang=pug"
import script from "./LightBox.vue?vue&type=script&lang=js"
export * from "./LightBox.vue?vue&type=script&lang=js"
import style0 from "./LightBox.vue?vue&type=style&index=0&id=3c58f82f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c58f82f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c58f82f')) {
      api.createRecord('3c58f82f', component.options)
    } else {
      api.reload('3c58f82f', component.options)
    }
    module.hot.accept("./LightBox.vue?vue&type=template&id=3c58f82f&scoped=true&lang=pug", function () {
      api.rerender('3c58f82f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/event/anniversary2023/components/LightBox.vue"
export default component.exports